export const ratingReviewsSelector = (period: string) => (state: any) => state.ratingReviews.data; 